import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { HoverCard, Text } from "@mantine/core";
import { IconAdjustmentsAlt } from "@tabler/icons-react";
import { selectEnabledDeveloperOverrides } from "./DeveloperOverrides";

// the header pills become unreadable on narrow windows, this stays visible at any width
const DeveloperOverridesIndicator = () => {
	const navigate = useNavigate();
	const developerOverrides = useSelector((state) => state.developerOverrides);
	const activeOverrides = useMemo(
		() => selectEnabledDeveloperOverrides({ developerOverrides }),
		[developerOverrides]
	);

	if (!activeOverrides.length) {
		return null;
	}

	return (
		<HoverCard
			position="top-end"
			openDelay={0}
			closeDelay={100}
			withinPortal
		>
			<HoverCard.Target>
				<button
					type="button"
					aria-label="Developer overrides active"
					onClick={() => navigate("/settings/developer")}
					style={{
						position: "fixed",
						bottom: 54,
						right: 24,
						zIndex: 1400,
						width: 40,
						height: 40,
						borderRadius: "50%",
						border: "none",
						backgroundColor: "var(--lw-gold)",
						display: "flex",
						alignItems: "center",
						justifyContent: "center",
						cursor: "pointer",
						boxShadow: "0 2px 6px rgba(0, 0, 0, 0.3)",
					}}
				>
					<IconAdjustmentsAlt size={22} />
				</button>
			</HoverCard.Target>
			<HoverCard.Dropdown style={{ padding: "8px 12px", maxWidth: 360 }}>
				<Text size="xs" fw="bold">
					Developer overrides active
				</Text>
				{activeOverrides.map(
					({ key, shortLabel, fullValueDescription }) => (
						<Text size="sm" key={key}>
							{shortLabel}: {fullValueDescription}
						</Text>
					)
				)}
			</HoverCard.Dropdown>
		</HoverCard>
	);
};

export default DeveloperOverridesIndicator;
